import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { DocumentIconFor } from "./document-icon";
import { ExamplePreviewModal } from "./example-preview-modal";
import type { DocumentExample } from "./types";

interface DocumentExampleListProps {
  examples: readonly DocumentExample[];
}

// Open an example in place. It is reference material to read, not a file the customer
// must collect before they can continue.
export const DocumentExampleList = ({ examples }: DocumentExampleListProps) => {
  const [selectedExample, setSelectedExample] =
    useState<DocumentExample | null>(null);

  if (!examples.length) return null;

  return (
    <Stack className="w-full" gap={2} align="stretch">
      <Text variant="caption" tone="muted">
        Examples
      </Text>
      <Stack className="w-full" gap={1} align="stretch">
        {examples.map((example) => (
          <Button
            key={example.href}
            variant="link"
            onClick={() => setSelectedExample(example)}
            className="w-full min-w-0 justify-start px-0"
          >
            <DocumentIconFor
              fileName={example.href}
              className="size-5 shrink-0 text-subtle"
            />
            <span
              className="min-w-0 flex-1 truncate text-left"
              title={example.label}
            >
              {example.label}
            </span>
          </Button>
        ))}
      </Stack>

      <ExamplePreviewModal
        example={selectedExample}
        onClose={() => setSelectedExample(null)}
      />
    </Stack>
  );
};
